import {createDailyPromoStorage} from './dailyPromoStorage';

// Приглашение в первый обычный сетевой матч (OnlineMatchPromoModal в главном
// меню): дата последнего закрытия — повторные показы, пока сетевого матча
// так и нет, не чаще раза в сутки. Отдельной отметки «пора показать» не
// нужно: право на первый показ дает сам профиль (бой с ботами уже сыгран,
// сетевого матча нет — см. resolveOnlineMatchPromoReason). Отметка «обучение
// только что пройдено» относится к предыдущей ступени воронки и живет в
// botMatchPromoStorage
export const ONLINE_MATCH_PROMO_SHOWN_AT_STORAGE_KEY = 'onlineMatchPromoShownAt';

const dailyStorage = createDailyPromoStorage(ONLINE_MATCH_PROMO_SHOWN_AT_STORAGE_KEY);

export const checkIfOnlineMatchPromoDue = dailyStorage.checkIfDue;
export const rememberOnlineMatchPromoShown = dailyStorage.rememberShown;
export const checkIfOnlineMatchPromoEverShown = dailyStorage.checkIfEverShown;
